// extracted by mini-css-extract-plugin
module.exports = {"linkWrap":"MineFriends_linkWrap__1D9Ip","earned":"MineFriends_earned__1U6MJ"};